module.exports = __webpack_public_path__ + "img/myfree.bio.ce506b31.jpg";